import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Console } from 'console';
import { TransformerManagerService } from '../services/transformerManager.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaintainanceplanningComponent } from './maintainanceplanning/maintainanceplanning.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transformermaintainance',
  templateUrl: './transformermaintainance.component.html',
  styleUrls: ['./transformermaintainance.component.scss']
})
export class TransformermaintainanceComponent implements OnInit {
  formGroup: FormGroup;
  siteName:any = [];
  inputs = Array(5).fill(null);
  transformerid;
  selectedSite;
  action = "add";
  selectedOptions: any[] = [];
  sitemanagers;
  loginUserData= JSON.parse(localStorage.getItem("userData"));
  alertsData=["Low Oil Level","High Oil Temperature","High Winding Temperature","Critiacl Load"]
  selectedValues: string[] = [];
  options;
  dropdownOpen = false; // State for dropdown visibility
  selectedParameters: any;

  constructor(private fb: FormBuilder,private transMngSer:TransformerManagerService,private dialogRef: MatDialogRef<MaintainanceplanningComponent>,private tostr:ToastrService,@Inject(MAT_DIALOG_DATA) public formdata: { data:any}
  ) { 
    
  }

  async ngOnInit() {
    this.formGroup = this.fb.group({
      sitename:  new FormControl(null, [Validators.required]),
      transformerid:  new FormControl(''),
      selectedOptions: [[]],
      date: new FormControl(null, [Validators.required]),
      maintainancetype: new FormControl(),
      engineername: new FormControl(null, [Validators.required]),
      resource: new FormControl(null, [Validators.required]),
      downtime:new FormControl(null, [Validators.required]),
      estimatedcost: new FormControl(null, [Validators.required]),
      notes:  new FormControl(null),
    });
    this.formGroup.get('maintainancetype').setValue("Predictive")
     this.siteName = await this.getDdlData();
     this.selectedSite = this.siteName[0];
      this.sitemanagers = this.siteName.map(site => site.sitemanager);
      this.getMaintenanceParameters();
      if(typeof this.formdata == 'object' && !Array.isArray(this.formdata)){
        console.log("form data",this.formdata)
        this.action = "edit";
        this.patchFormData(this.formdata);
      }
    }
  getTransformerID(sitename){
    this.formGroup.controls['transformerid'].setValue(sitename.serialnumber);
  }
  getDdlData() {
    return new Promise((resolve, reject) => {
        this.transMngSer.getTransformerData(JSON.parse(localStorage.getItem('userData')).roleid, JSON.parse(localStorage.getItem('userData')).userid, 'x``z').toPromise().then((response: any) => {
             if(response.data.length > 0)
             {
                resolve(response.data);
             }
            resolve([]);
        });
    })
}
getMaintenanceParameters(){
  this.transMngSer.getMaintenanceParameters().toPromise().then((response: any) => {
    if(response.data.length > 0)
    { 
      this.options = response.data.map(val => val.parameters);
      console.log(this.options)


    }
  });
}

patchFormData(valuesObject){
  this.formGroup.patchValue({
    sitename: valuesObject.sitename,
    transformerid: valuesObject.transformerid,
    selectedOptions: valuesObject.selectedOptions.split(',').map(option => option.trim()),
    date: new Date(valuesObject.date),
    maintainancetype: valuesObject.maintainancetype,
    engineername: valuesObject.engineername,
    resource: valuesObject.resource,
    downtime: valuesObject.downtime,
    estimatedcost: valuesObject.estimatedcost,
    notes: valuesObject.notes,
  });
  Object.keys(this.formGroup.controls).forEach((field) => {
    const control = this.formGroup.get(field);
    if (control) {
      control.disable();
    }
  });
}
editData(){
  Object.keys(this.formGroup.controls).forEach((field) => {
    const control = this.formGroup.get(field);
      if (control) {
        control.enable();
      }
  });
}
submit(data){
let maintenanceData = data.value;
maintenanceData.login_user_id = this.loginUserData.userid;
maintenanceData.selectedOptions = maintenanceData.selectedOptions.join(', ');
maintenanceData.action = this.action;
let msg = "Plan Created";
if(this.action == "edit"){
  maintenanceData.id = this.formdata['id'];
  msg  = "Plan Updated"
}
console.log("MaintainanceData",maintenanceData);

this.transMngSer.saveMaintaianceData(maintenanceData).toPromise().then((response: any) => {
  if(response.code ==1)
  {
    this.tostr.success(msg)
    this.dialogRef.close();
  }
});
}
}
